export default function () {
  if (document.getElementById('address-details-app')) {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackChunkName: "address-details-app" */ '../_03_organisms/address-details/main');
  }
}
